import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";


import api from "../../../service/api";

import { Container, Row } from "react-bootstrap";

import Header from "../../../components/Header";
import Table from "../../../components/Table";
import NavTabs from "../../../components/NavTabs";

import SideContainerAnimated from "../../../components/SideContainer";
import SideForm from "../../../components/SideForm";
import Input from "../../../components/Input/index";
import Button from "../../../components/Button/index";
import DropdownButton from "../../../components/DropdownButton";
import Modal from "../../../components/ModalSuccessMessage";
import Tooltip from "../../../components/Tooltip";
import ErrorMessage from "../../../components/ErrorMessage";
import ModalClientsDetail from "../../../components/ModalClientsDetail";
import Animation from "../../../components/Animation/animation";

import {  Legend, THead, Th, ThFilterable, Td, InputWithHintContainer, Select, ContainerInput } from "./styles";

import routes from "../../../routes/subscription.routes";
import Main from "../../../components/Main/index";

//Utils Functions
import { translateFrequencyOrInterval } from "../../../utils/translate/frequencyOrInterval";

//Help Functions
import { openModal } from "../../../helpers/modalFunctions";

//Help Variables
import { serverPath } from "../../../helpers/helpersVariables";

//Interfaces
import { RecurrencePlanDataInterface } from "./interfaces";

//Assets
import addRecurrence from "../../../assets/icons/addRecurrence.svg";
import upArrow from "../../../assets/icons/chevron-up.svg";
import downArrow from "../../../assets/icons/chevron-down.svg";
import hint from "../../../assets/icons/hint.svg"

import { ToastContainer } from "react-toastify";

// Utils
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { notifysFieldsForm } from "../../../utils/notifications/notifyForm";
import convertAmountInCents from "../../../utils/amountInCents";
import MsgErrorInput from "../../../components/MsgErrorInput";

const RecurrencePlan = () => {
  const [isAddFormVisible, setIsAddFormVisible] = useState(false);
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);
  const [recurrencePlanData, setRecurrencePlanData] = useState<Array<RecurrencePlanDataInterface>>([]);
  const [selectedPlan, setSelectedPlan] = useState<RecurrencePlanDataInterface>({
    id: "",
    paymentMethods: "",
    amount: "",
    duration: "",
    tolerancePeriod: "",
    description: "",
    interval: "",
    name: "",
    frequency: "",
    recurrenceOwnerId: "",
    recurrenceBranchId: "",
    currency: "",
    setupAmount: "",
    resource: "",
    isActive: false,
    gracePeriod: "",
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const [errorOnSubmit, setErrorOnSubmit] = useState(false);
  const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);

  //Estados para exibição dos Tooltips
  const [frequencyTooltip, setFrequencyTooltip] = useState(false);
  const [intervalTooltip, setIntervalTooltip] = useState(false);
  const [paymentMethodTooltip, setPaymentMethodTooltip] = useState(false);
  const [gracePeriodTooltip, setGracePeriodTooltip] = useState(false);
  const [amountTooltip, setAmountTooltip] = useState(false);
  const [setupAmountTooltip, setSetupAmountTooltip] = useState(false);
  const [toleranceTooltip, setToleranceTooltip] = useState(false);
  const [durationTooltip, setDurationTooltip] = useState(false);
  // fim dos estados para Tooltip

  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const login = useSelector((state: {login: any}) => state.login);
  const history = useHistory();
    
  useEffect(() => {
      if(login.user.groups.cm5a2 === false){
          history.push("/admin/dashboard");
      }
  }, []);

  useEffect(() => {
    const getRecurrenceDataFromApi = async () => {

      const { data } = await api.get("/recurrence/list", {
        params: {
          page,
          branchsId: login.user.branchsId
        }
      });

      setRecurrencePlanData(data.Plan);
      setMaxPage(data.pageCount)
      setIsLoading(false);
    }

    if(searchTerm === ""){
      getRecurrenceDataFromApi();
    }
  }, [page, searchTerm]);

  useEffect(() => {
    setIsLoading(true);
    const timerId = setTimeout(() => {
        setPage(1);
        setDebouncedSearchTerm(searchTerm);
    }, 1200);

    return () => {
        clearTimeout(timerId);
    }
  }, [searchTerm]);

  useEffect(() => {
    const getRecurrenceFilteredAtApi = async () => {
      const {data} = await api.get("/recurrence/list", {
        params: {
          page,
          branchsId: login.user.branchsId,
          search: debouncedSearchTerm
        }
      });

      setRecurrencePlanData(data.Plan);
      setIsLoading(false);
    }

    if(debouncedSearchTerm !== ""){
      getRecurrenceFilteredAtApi();
    }
  }, [debouncedSearchTerm, page]);

  const openAddForm = () => {
    if(isEditFormVisible != true) {
        setIsAddFormVisible(true);
    }
  }

  const openEditForm = () => {
    if(isAddFormVisible != true) {
        setIsEditFormVisible(true);
    }
  }

  const formValidationWithYup =  Yup.object().shape({
    name: Yup.string().required("*Obrigatório"),
    description: Yup.string().required("*Obrigatório"),
    frequency: Yup.string().required("*Obrigatório"),
    interval: Yup.number().required("*Obrigatório").moreThan(-1, "*Deve ser maior ou igual a 0").integer("*Deve ser um número inteiro"),
    paymentMethods: Yup.string().required("*Obrigatório"),
    gracePeriod: Yup.number().required("*Obrigatório").integer("*Deve ser um número inteiro"),
    amount: Yup.string().required("*Obrigatório"),
    setupAmount: Yup.string().required("*Obrigatório"),
    tolerancePeriod: Yup.number().required("*Obrigatório").moreThan(-1,"*Deve ser maior ou igual a 0").integer("*Deve ser um número inteiro"),
    duration: Yup.number().required("*Obrigatório").moreThan(0, "*Duração deve ser maior que 0").integer("*Deve ser um número inteiro"),
  });

  const searchForErrors = (errors: Object) => {
    if(errors !== {}){
      setErrorOnSubmit(true)
    } else {
      setErrorOnSubmit(false)
    }
  }

  const handleExport = async () => {
    const {data} = await api.get("/recurrence/list", {
      params: {
        branchsId: login.user.branchsId,
        exportFilter: true
      }
    });

    window.open(`${serverPath}/${data}`);
  }

  function tableContentGenerator() {
    if(recurrencePlanData.length > 0){
      return recurrencePlanData.map((plan) => (
        <tr key={plan.id} style={{ height: 67 }}>
          <Td>{plan.id}</Td>
          <Td>{plan.name}</Td>
          <Td>{translateFrequencyOrInterval(plan.frequency)}</Td>
          <Td>{plan.interval}</Td>
          <Td>{plan.isActive ? "Ativo" : "Inativo"}</Td>
          <Td>{plan.paymentMethods === "credit" ? "Crédito" : plan.paymentMethods}</Td>
          <Td>R$ {(parseFloat(plan.amount.replace(",", ".")) / 100).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Td>
          <Td>R$ {(parseFloat(plan.setupAmount.replace(",", ".")) / 100).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Td>
          <Td>{plan.duration}</Td>
          <Td>
            <DropdownButton 
              isViewOptionVisible={true} //login.user.groups.cm5a2r
              isRemoveOPtionVisible={false} //login.user.groups.cm5a2d
              selectedUser={plan}
              setSelectedUser={setSelectedPlan}
              openModal={true}
              modalId={"#details-plans"}
            />
          </Td>
        </tr>
      ));
    }
  }

  const openForm =  isAddFormVisible || isEditFormVisible;

  return (
    <Container fluid>
      <ToastContainer/>
      <Row>
      {<ModalClientsDetail title="Informações do plano" type="plan" data={selectedPlan}/>} 
        <Modal text="Plano gerado com Sucesso"/>
        <Main className={` ${openForm ? "col-d-none column-side-open" : "column-content"}`} isFormVisible={isAddFormVisible}>
          
            <Header
                title="Assinatura"
                subTitle="Gere pagamentos via boleto bancário de forma fácil e rápida."
                subTitleWidth={236}
            />
            <NavTabs tabs={routes}/>

            <Table
                showAddButton={login.user.groups.cm5a2c}
                showExportButton={login.user.groups.cm5a2e}
                handleExport={handleExport}
                buttonText="Criar Plano"
                isAddFormVisible={isAddFormVisible}
                setIsAddFormVisible={openAddForm}
                page={page}
                maximumPage={maxPage}
                setPage={setPage}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
            >
              <THead>
                <tr>
                  <ThFilterable>
                    <div>ID</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                      <img src={upArrow} alt="seta para cima" />
                      <br />
                      <img src={downArrow} alt="seta para baixo" />
                    </div>
                  </ThFilterable>
                  <Th>Plano</Th>
                  <ThFilterable>
                    <div>Frequência</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                      <img src={upArrow} alt="seta para cima" />
                      <br />
                      <img src={downArrow} alt="seta para baixo" />
                    </div>
                  </ThFilterable>
                  <Th>Intervalo</Th>
                  <ThFilterable>
                    <div>Status</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                      <img src={upArrow} alt="seta para cima" />
                      <br />
                      <img src={downArrow} alt="seta para baixo" />
                    </div>
                  </ThFilterable>
                  <Th>Método de Pagamento</Th>
                  <Th>Valor do plano</Th>
                  <Th>Valor do Setup</Th>
                  <Th>Duração</Th>
                  <Th></Th>
                </tr>
              </THead>
              {
                isLoading 
                ? <Animation/>
                : <tbody>
                    { tableContentGenerator() }
                </tbody>
              }
            </Table>

        </Main>

        <SideContainerAnimated isVisible={isAddFormVisible}>
          <SideForm title="Criar Plano" icon={addRecurrence} visible={setIsAddFormVisible}>
            <Formik
              initialValues={{
                name: "",
                description: "",
                frequency: "",
                interval: "",
                paymentMethods: 10,
                gracePeriod: "",
                amount: "",
                setupAmount: "",
                tolerancePeriod: "",
                duration: "",
              }}
              validationSchema={formValidationWithYup}
              onSubmit={async (values, { resetForm }) => {
                let amountInCents;
                let setupAmountInCents;

                amountInCents = convertAmountInCents(values.amount)
                setupAmountInCents = convertAmountInCents(values.setupAmount)

                try{
                  await api.post("/recurrence/create", {
                    name: values.name,
                    description: values.description,
                    frequency: values.frequency,
                    interval: values.interval,
                    paymentMethods: "credit",
                    gracePeriod: values.gracePeriod,
                    amount: amountInCents.toString(),
                    setupAmount: setupAmountInCents.toString(),
                    tolerancePeriod: values.tolerancePeriod,
                    duration: values.duration,
                    recurrenceOwnerId: login.user.branchs.sellerOwner100PayId,
                    recurrenceBranchId: login.user.branchsId,
                    currency:"BRL",
                  });
                  
                  const {data} = await api.get(`/recurrence/list?page=${page}&branchsId=${login.user.branchsId}`);
                  
                  setRecurrencePlanData(data.Plan);
                  setErrorOnReturnApi(false);
                  openModal("exampleModal");
                  toastUpdate("btnSubmit", "success", 3000, "Sucesso")
                  resetForm();
                } catch (e) {
                  setErrorOnReturnApi(true);
                  toastUpdate("btnSubmit","error",4000, "Ocorreu um problema, entre em contato com o suporte." )
                }
              }}
            >
              {({errors, touched, isValid, dirty}) => {
                return(

                  <Form id="form-subscription" style={{ width: "100%", marginTop: 41 }}>
                  <fieldset>
                      <Legend>Dados Principais</Legend>
                      <ContainerInput>
                        <Field 
                          id="name" 
                          name="name" 
                          className="inputCustom" 
                          style={{borderColor: `${touched.name && errors.name ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                          placeholder="Nome do Plano" 
                          as={Input}
                        />
                        { touched.name && errors.name ? <MsgErrorInput>{ errors.name }</MsgErrorInput> : null }
                      </ContainerInput>
                      <ContainerInput>
                        <Field 
                          id="description" 
                          name="description" 
                          className="inputCustom" 
                          style={{borderColor: `${touched.description && errors.description ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                          placeholder="Descrição" 
                          as={Input}
                        />
                        { touched.description && errors.description ? <MsgErrorInput>{ errors.description }</MsgErrorInput> : null }
                      </ContainerInput>
                      <div className="row">
                          <div className="col-lg-6">
                              <InputWithHintContainer>
                                  <ContainerInput>
                                    <Field 
                                      id="frequency" 
                                      name="frequency" 
                                      style={{borderColor: `${touched.frequency && errors.frequency ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                      as={Select}
                                    >
                                        <option disabled hidden value={""}>Frequência</option>
                                        <option value="daily">Diário</option>
                                        <option value="weekly">Semanal</option>
                                        <option value="monthly">Mensal</option>
                                        <option value="annually">Anual</option>
                                    </Field>
                                    { touched.frequency && errors.frequency ? <MsgErrorInput style={{top: 30}}>{ errors.frequency }</MsgErrorInput> : null }
                                  </ContainerInput>
                                  <div>
                                    <img src={hint} style={{marginLeft: 3}}
                                      onMouseEnter={() => {setFrequencyTooltip(true)}}
                                      onMouseLeave={() => {setFrequencyTooltip(false)}}
                                    />
                                    {frequencyTooltip ? <Tooltip text="Frequência que o plano será cobrado" margin={140}/> : null}
                                  </div>
                              </InputWithHintContainer>
                          </div>
                          <div className="col-lg-6">
                              <InputWithHintContainer>
                                    <ContainerInput>
                                      <Field 
                                        id="interval" 
                                        name="interval" 
                                        placeholder="Intervalo" 
                                        style={{borderColor: `${touched.interval && errors.interval ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                        type="number" 
                                        as={Input}
                                      />
                                      { touched.interval && errors.interval ? <MsgErrorInput style={{top: 30}}>{ errors.interval }</MsgErrorInput> : null }
                                    </ContainerInput>
                                  <div>
                                    <img src={hint} style={{marginLeft: 3}} 
                                      onMouseEnter={() => {setIntervalTooltip(true)}}
                                      onMouseLeave={() => {setIntervalTooltip(false)}}
                                    />
                                    {intervalTooltip ? <Tooltip text="Intervalo entre frequência de cobrança"/> : null}
                                  </div>
                              </InputWithHintContainer>
                          </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <InputWithHintContainer>
                                <ContainerInput>
                                  <Field 
                                    id="gracePeriod" 
                                    name="gracePeriod" 
                                    style={{borderColor: `${touched.gracePeriod && errors.gracePeriod ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    placeholder="Período de Carência" 
                                    type="number"
                                    as={Input}
                                  />
                                  { touched.gracePeriod && errors.gracePeriod ? <MsgErrorInput style={{top: 30}}>{ errors.gracePeriod }</MsgErrorInput> : null }
                                </ContainerInput>
                              <div>
                                <img src={hint} style={{marginLeft: 3}} 
                                  onMouseEnter={() => {setGracePeriodTooltip(true)}}
                                  onMouseLeave={() => {setGracePeriodTooltip(false)}}
                                />
                                {gracePeriodTooltip ? <Tooltip text="Período de carência para primeira cobrança"/> : null}
                              </div>
                          </InputWithHintContainer>
                        </div>
                      </div>
                      <div className="row">
                          <div className="col-lg-6">
                              <InputWithHintContainer>
                                  
                                  <ContainerInput>
                                    <Field 
                                      id="amount" 
                                      name="amount"
                                      type="text"
                                      style={{borderColor: `${touched.amount && errors.amount ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                      placeholder="Valor do Plano" 
                                      as={Input}
                                    />
                                    { touched.amount && errors.amount ? <MsgErrorInput style={{top: 30}}>{ errors.amount }</MsgErrorInput> : null }
                                  </ContainerInput>
                                  <div>
                                    <img src={hint} style={{marginLeft: 3}} 
                                      onMouseEnter={() => {setAmountTooltip(true)}}
                                      onMouseLeave={() => {setAmountTooltip(false)}}
                                    />
                                    {amountTooltip ? <Tooltip text="Valor do plano" margin={140}/> : null}
                                  </div>
                              </InputWithHintContainer>
                          </div>
                          <div className="col-lg-6">
                              <InputWithHintContainer>
                                  <ContainerInput>
                                    <Field 
                                      id="setupAmount" 
                                      name="setupAmount"
                                      type="text"
                                      style={{borderColor: `${touched.setupAmount && errors.setupAmount ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                      placeholder="Valor do Setup" 
                                      as={Input}
                                    />
                                    { touched.setupAmount && errors.setupAmount ? <MsgErrorInput style={{top: 30}}>{ errors.setupAmount }</MsgErrorInput> : null }
                                  </ContainerInput>
                                  <div>
                                    <img src={hint} style={{marginLeft: 3}} 
                                      onMouseEnter={() => {setSetupAmountTooltip(true)}}
                                      onMouseLeave={() => {setSetupAmountTooltip(false)}}
                                    />
                                    {setupAmountTooltip ? <Tooltip text="Valor do setup do plano"/> : null}
                                  </div>
                              </InputWithHintContainer>
                          </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <InputWithHintContainer>
                                <ContainerInput>
                                  <Field 
                                    id="tolerancePeriod" 
                                    name="tolerancePeriod" 
                                    style={{borderColor: `${touched.tolerancePeriod && errors.tolerancePeriod ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    placeholder="Tolerância na Falha" 
                                    type="number" 
                                    as={Input}
                                  />
                                  { touched.tolerancePeriod && errors.tolerancePeriod ? <MsgErrorInput style={{top: 30}}>{ errors.tolerancePeriod }</MsgErrorInput> : null }
                                </ContainerInput>
                              <div>
                                <img src={hint} style={{marginLeft: 3}} 
                                  onMouseEnter={() => {setToleranceTooltip(true)}}
                                  onMouseLeave={() => {setToleranceTooltip(false)}}
                                />
                                {toleranceTooltip ? <Tooltip text="Prazo de tolerância em caso de atraso no pagamento"/> : null}
                              </div>
                          </InputWithHintContainer>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <InputWithHintContainer>
                                <ContainerInput>
                                  <Field 
                                    id="duration" 
                                    name="duration" 
                                    style={{borderColor: `${touched.duration && errors.duration ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                    placeholder="Duração do Plano" 
                                    type="number" 
                                    as={Input}
                                  />
                                  { touched.duration && errors.duration ? <MsgErrorInput style={{top: 30}}>{ errors.duration }</MsgErrorInput> : null }
                                </ContainerInput>
                              <div>
                                <img src={hint} style={{marginLeft: 3}} 
                                  onMouseEnter={() => {setDurationTooltip(true)}}
                                  onMouseLeave={() => {setDurationTooltip(false)}}
                                />
                                {durationTooltip ? <Tooltip text="Tempo de duração do plano em relação à frequencia escolhida"/> : null}
                              </div>
                          </InputWithHintContainer>
                        </div>
                      </div>
                    </fieldset>
                    {notifysFieldsForm(errors, errorOnSubmit)}
                    {
                      errorOnReturnApi ? 
                        <ErrorMessage>
                          Falha ao criar plano de recorrência
                        </ErrorMessage> : null
                    }
                    <Button 
                      type="submit" 
                      className="buttonCustom"
                      disabled={!(isValid && dirty)}
                      onClick={() => {
                        searchForErrors(errors);
                        toastCreate("btnSubmit", "info", 3000, "Processando")
                      }}
                    >
                      Adicionar
                    </Button>
                  </Form>
                )
              }}
            </Formik>
          </SideForm>
        </SideContainerAnimated>
      </Row>
    </Container>
  );
};

export default RecurrencePlan;
